export const getNotificationBannerStyle = (type, token) => {
    switch (type) {
        case 'PUSH_NOTIFICATION':
            return {
                titleColor: token.BMUiBannerTitleInkContrast,
                messageColor: token.BMUiBannerMessageInkContrast,
                backgroundColor: token.BMUiBannerBgcolorContrast,
            };
        case 'GREEN':
            return {
                titleColor: token.BMUiBannerTitleInkGreen,
                messageColor: token.BMUiBannerMessageInkGreen,
                backgroundColor: token.BMUiBannerBgcolorGreen,
            };
        case 'RED':
            return {
                titleColor: token.BMUiBannerTitleInkRed,
                messageColor: token.BMUiBannerMessageInkRed,
                backgroundColor: token.BMUiBannerBgcolorRed,
            };
        case 'YELLOW':
            return {
                titleColor: token.BMUiBannerTitleInkYellow,
                messageColor: token.BMUiBannerMessageInkYellow,
                backgroundColor: token.BMUiBannerBgcolorYellow,
            };
        case 'BLUE':
            return {
                titleColor: token.BMUiBannerTitleInkBlue,
                messageColor: token.BMUiBannerMessageInkBlue,
                backgroundColor: token.BMUiBannerBgcolorBlue,
            };
        case 'GREY':
            return {
                titleColor: token.BMUiBannerTitleInkGrey,
                messageColor: token.BMUiBannerMessageInkGrey,
                backgroundColor: token.BMUiBannerBgcolorGrey,
            };
        default:
            throw new Error(`Unknown Notification Banner type: ${type}`);
    }
};
